import { NgModule } from 'ng-metadata/core';
import { FormUsaStateComponent } from './usa-state.component';

@NgModule({
  declarations: [FormUsaStateComponent],
})
export class FormUsaStateModule { }



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/usa-state/usa-state.module.ts